import { t } from "@repo/translation";
import { FilterCheckbox } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";

interface ConsentFilterProps {
  id: string;
  value?: string;
  onChange: (value: string | undefined) => void;
}
export const ConsentFilter = ({ id, value, onChange }: ConsentFilterProps) => {
  return (
    <FilterListContainer id="consent-filter">
      <FilterCheckbox
        id={`${id}-yes`}
        value="yes"
        label={t("label.yes")}
        checked={value === "yes"}
        onCheckFilter={() => {
          onChange(value === "yes" ? undefined : "yes");
          trackAnalytics("yes_to_consent");
        }}
      />
      <FilterCheckbox
        id={`${id}-no`}
        value="no"
        label={t("label.no")}
        checked={value === "no"}
        onCheckFilter={() => {
          onChange(value === "no" ? undefined : "no");
          trackAnalytics("no_to_consent");
        }}
      />
      <FilterCheckbox
        id={`${id}-pending`}
        value="pending"
        label={t("label.pending")}
        checked={value === "pending"}
        onCheckFilter={() => {
          onChange(value === "pending" ? undefined : "pending");
          trackAnalytics("pending_consent");
        }}
      />
    </FilterListContainer>
  );
};
